<template>
  <div class="home">
    <v-container class="text-start">
      <SectionHome class="text-center" :content="dailyPosts.Hadith">
        <template v-slot:Titel>حديث اليوم</template>
      </SectionHome>
      <div class="question-day mt-8">
        <h3 class="text-center font text-green">سؤال اليوم</h3>
        <v-card
          class="mx-auto rounded-lg cover text-center text-white font pa-2 py-3"
          style="width: 80%"
          min-width="100"
          min-height="80"
        >
          {{ dailyPosts.question.questionText }}
        </v-card>
        <v-item-group
          class="w-75 mx-auto mt-2"
          v-model="selcted"
          mandatory
          :disabled="selcted != null"
        >
          <v-row>
            <v-col cols="12">
              <v-item
                v-for="answer in dailyPosts.question.answers"
                :key="answer"
                v-slot="{ isSelected, toggle }"
              >
                <v-card
                  style="transition: 0.8s ease-in-out"
                  class="my-2 text-start px-3 text-end font"
                  @click="toggle"
                  :class="
                    isSelected
                      ? `text-white ${
                          answer.isTrue ? 'true-answer' : 'false-answer'
                        }`
                      : 'bg-transparent'
                  "
                  elevation="0"
                >
                  {{ answer.answer }}
                  <span class="icons" v-if="selcted != null">
                    <v-icon :color="answer.isTrue ? '#42b983' : 'red'">{{
                      answer.isTrue ? "mdi-check-circle" : "mdi-close-circle"
                    }}</v-icon>
                  </span>
                  <span class="icons" v-else>
                    <v-icon color="#BDBDBD"> mdi-circle-outline </v-icon>
                  </span>
                </v-card>
              </v-item>
            </v-col>
          </v-row>
        </v-item-group>
      </div>
      <SectionHome class="text-center" :content="dailyPosts.duea">
        <template v-slot:Titel>دعاء اليوم</template>
      </SectionHome>
      <!-- dvider -->
      <v-card
        class="mx-auto my-5 pa-1"
        max-width="300"
        color="#2fd07c"
        elevation="0"
      >
      </v-card>
      <!-- dvider -->
      <SectionHome
        class="text-center"
        :name="dailyPosts.NamesOfAllah.name"
        :content="dailyPosts.NamesOfAllah.text"
      >
        <template v-slot:Titel> اسماء الله الحسنى</template>
      </SectionHome>
      <!-- AdeiaHome -->
      <AdeiaHome v-for="item in dailyPosts.TransDuea" :key="item">
        <template v-slot:Ar>
          {{ item.ar }}
        </template>
        <template v-slot:En>
          {{ item.en }}
        </template>
      </AdeiaHome>
    </v-container>
  </div>
</template>
<script>
import SectionHome from "@/components/SectionHome.vue";
import AdeiaHome from "@/components/AdeiaHome.vue";
import { mapActions, mapState } from "pinia";
import { homeStore } from "@/store/homeStore";
export default {
  name: "HomeView",
  data: () => {
    return {
      selcted: null,
    };
  },
  computed: {
    ...mapState(homeStore, ["dailyPosts"]),
  },
  methods: { ...mapActions(homeStore, ["getdocs"]) },
  components: { SectionHome, AdeiaHome },
  mounted() {
    this.getdocs();
  },
};
</script>
<style scoped>
.cover {
  background-image: url("../assets/cover.png");
  background-size: cover;
  background-color: #2fd07c;
}
.true-answer {
  background-color: #99d4a8;
}
.false-answer {
  background-color: #f7a8a8;
}
</style>
